import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ArgumentTreeType } from "#/entities/argument/model/types";
import { type TreeNodeData } from "#/entities/dataStructures/node/model/nodeSlice";
import { NodeBase } from "#/features/treeViewer/ui/NodeBase";
import { useNodeColors } from "#/shared/hooks";
import { useLinkedListChildNode } from "../hooks";
export type LinkedListProps = TreeNodeData & {
  treeName: string;
  type: ArgumentTreeType;
};
export const LinkedListNode: React.FC<LinkedListProps> = props => {
  const $ = _c(4);
  const {
    color
  } = props;
  const {
    nodeColor,
    shadowColor
  } = useNodeColors(color);
  useLinkedListChildNode(props);
  let t0;
  if ($[0] !== nodeColor || $[1] !== props || $[2] !== shadowColor) {
    t0 = <NodeBase nodeColor={nodeColor} shadowColor={shadowColor} {...props} />;
    $[0] = nodeColor;
    $[1] = props;
    $[2] = shadowColor;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};